import getMinimumSelectedDays from 'ha/utils/datePickerCalculations/getMinimumSelectedDays';
import { addDays } from '@ha/date';

// Calculates the first available "To" date: "From" date + minimal rental period (in days)
const calcFirstAvailableToDate = (from: Date, minimumPeriod: number) => {
  const minimumSelectedDays = getMinimumSelectedDays(
    from.toISOString(),
    minimumPeriod,
  );

  return new Date(addDays(from.toISOString(), minimumSelectedDays));
};

export default calcFirstAvailableToDate;
